module.exports = __webpack_public_path__ + "static/media/IC.821b1b85.png";